<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ROZ2gv/tc-custom/9780316077002.jpg?1732164576924" alt="This image is the cover for the book City Boy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">City Boy
      </h1>
      <p class="bookDescription body article font2">
        <b>An "enormously entertaining" portrait of "a Bronx Tom Sawyer" (<i>San Francisco Chronicle</i>), <i>City Boy</i> is a sharp and moving novel of boyhood from Pulitzer Prize winner Herman Wouk. </b><br/><br/>A hilarious and often touching tale of an urban kid's adventures and misadventures on the street, in school, in the countryside, always in pursuit of Lucille, a heartless redhead personifying all the girls who torment and fascinate pubescent lads of eleven.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herman Wouk
      </h2>
      
      <p class="authorDescription body article">Herman Wouk (1915&ndash;2019) was a Pulitzer Prize&ndash;winning author of fiction and nonfiction. His works include <I>The Caine Mutiny</I>,<I> Marjorie Morningstar</I>,<I> The Hope</I>, and<I> The Glory</I>. Several of his books have been adapted into films and miniseries. Wouk&rsquo;s early career as a radio comedy writer included a stint on the Fred Allen Show. He later became a naval officer after the attack on Pearl Harbor in 1941. The son of Russian Jewish immigrants, Wouk&rsquo;s novels <I>The Winds of War </I>and <I>War and Remembrance </I>delve into Jewish peoples experiences during World War II. In 1999, he received the Jewish Book Council Lifetime Achievement Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f882e46